import {useEffect, useRef, useState} from "react";
import gsap from "gsap";
import {usePageContext} from "@/context/PageContext";

export default function useAnimationThemeSelector({containerRef, overlayRef}) {
	const tl = useRef()
	const {activeTheme} = usePageContext()
	const [isFirstRender, setIsFirstRender] = useState(true)

	// Create animation timeline and destroy it on unmount
	useEffect(() => {
		tl.current = createAnimation(tl, containerRef, overlayRef)

		return () => {
			tl.current.kill()
		}
	}, [])

	// Play animation on theme change
	useEffect(() => {
		// Skip animation if no timeline
		if (!tl.current) return

		// Skip animation on first render
		if (isFirstRender) {
			setIsFirstRender(false)
			return
		}

		// Play animation
		tl.current.play(activeTheme === 'light' ? 'startOfLightToDark' : 'startOfDarkToLight')
	}, [activeTheme])
}

const createAnimation = (tl, containerRef, overlayRef) => {
	tl.current = gsap.timeline({defaults: {duration: .5}})

	// Get container width and height
	const {width: containerWidth, height: containerHeight} = containerRef.current.getBoundingClientRect()
	const overlayPadding = 2

	// Calculate width and height of the overlay
	const overlayHeight = containerHeight - (overlayPadding * 2)

	// Make overlay full width
	tl.current.addLabel('startOfLightToDark', 0)
			.to(overlayRef.current, {
				left: 2,
				ease: 'elastic.out(1, .8)',
				duration: .5,
			}, '<')

	// Make overlay round
	tl.current.to(overlayRef.current, {
		right: containerWidth - overlayHeight - overlayPadding,
		ease: 'elastic.out(1, .8)',
		duration: .25,
	}, '>')
			.addLabel('endOfLightToDark')
			.addPause()

			// // Make overlay full width
			.addLabel('startOfDarkToLight')
	tl.current.to(overlayRef.current, {
		right: 2,
		ease: 'elastic.out(1, .8)',
		duration: .5,
	}, '>')

	// Make overlay round
	tl.current.to(overlayRef.current, {
		left: containerWidth - overlayHeight - overlayPadding,
		ease: 'elastic.out(1, .8)',
		duration: .25,
	}, '>')
			.addLabel('endOfDarkToLight')
			.addPause()
			.pause()

	return tl.current
}
